import { styled } from '@project44/manifest-ds';

export const BodyContainer = styled('div', {
  display: 'flex',
  alignItems: 'center',
  padding: '0 16px',
  color: '#fff',
  background: '#091521',
  boxShadow:
    '0px -1px 2px rgba(61, 58, 180, 0.1), 0px 6px 14px rgba(61, 58, 180, 0.15);',
  borderRadius: '2px',
});

export const MessageContainer = styled('div', {
  display: 'flex',
  padding: '4px 0',
  minHeight: '44px',
  alignItems: 'center',
  width: 'max-content',
});

export const Close = styled('div', {
  display: 'flex',
  alignItems: 'center',
  cursor: 'pointer',
  marginLeft: 4,
  padding: '0 4px',
});
